<po-page-dynamic-search
  [p-actions]="pageActions"
  [p-literals]="searchLiterals"
  (p-quick-search)="onQuickSearch($event)"
  (p-change-disclaimers)="onChangeDisclaimers($event)"
>
  <po-table
    [p-columns]="columns"
    [p-items]="rows"
    [p-actions]="tableActions"
    p-actions-right="true"
    p-striped="true"
    p-sort="true"
    p-spacing="small"
    [p-height]="tableFit.height"
    [p-loading]="loading"
    [p-literals]="{ noData: 'Nenhuma tribe cadastrada. Use Nova tribe para começar.' }"
  >
    <ng-template p-table-cell-template let-column="column" let-row="row">
      <ng-container *ngIf="column.property === 'areasCount'">
        <po-link *ngIf="row.areasCount" [p-label]="row.areasCount + ''" (p-action)="showAreas(row)"></po-link>
        <po-link *ngIf="!row.areasCount" p-label="Vincular" (p-action)="openLinkAreas(row)"></po-link>
      </ng-container>
      <ng-container *ngIf="column.property === 'usersCount'">
        <po-link *ngIf="row.usersCount" [p-label]="row.usersCount + ''" (p-action)="showUsers(row)"></po-link>
        <span *ngIf="!row.usersCount">0</span>
      </ng-container>
    </ng-template>
  </po-table>
</po-page-dynamic-search>

<!-- Nova / renomear tribe -->
<po-modal
  #tribeModal
  [p-title]="editingTribe ? 'Renomear tribe' : 'Nova tribe'"
  p-size="sm"
  [p-primary-action]="tribePrimaryAction"
  [p-secondary-action]="tribeCancel"
>
  <po-input
    name="tribeName"
    p-label="Nome da tribe"
    p-required
    p-clean
    [p-help]="editingTribe ? 'O novo nome aparece para todas as áreas e usuários da tribe.' : 'Depois de salvar, você escolhe as áreas da tribe.'"
    [ngModel]="tribeName"
    (ngModelChange)="onTribeNameChange($event)"
  ></po-input>
  <p *ngIf="tribeNameError" class="tribes-error">{{ tribeNameError }}</p>
</po-modal>

<!-- Vincular áreas -->
<po-modal
  #linkAreasModal
  [p-title]="'Áreas da tribe ' + (linkingTribe?.tribe || '')"
  p-size="lg"
  [p-primary-action]="linkPrimaryAction"
  [p-secondary-action]="linkCancel"
>
  <po-input
    name="linkSearch"
    p-icon="po-icon-search"
    p-placeholder="Buscar área ou tribe atual"
    p-clean
    [ngModel]="linkSearch"
    (ngModelChange)="onLinkSearch($event)"
  ></po-input>

  <po-table
    p-selectable="true"
    p-hide-columns-manager="true"
    p-spacing="small"
    p-striped="true"
    p-height="320"
    [p-items]="linkVisibleRows"
    [p-columns]="linkColumns"
    (p-selected)="onLinkRowToggle($event, true)"
    (p-unselected)="onLinkRowToggle($event, false)"
    (p-all-selected)="onLinkAllToggle(true)"
    (p-all-unselected)="onLinkAllToggle(false)"
  ></po-table>

  <p class="tribes-hint" *ngIf="linkSummary.entering.length || linkSummary.leaving.length">
    <strong>{{ linkSummary.entering.length }}</strong> entram<span *ngIf="movedFromOtherTribes"> ({{ movedFromOtherTribes }} vindas de outra tribe)</span>
    · <strong>{{ linkSummary.leaving.length }}</strong> saem e ficam sem tribe
  </p>
</po-modal>
